import React, {useEffect, useState} from 'react'
import {Box, Image} from "@chakra-ui/react";
import logo from "../../images/logo_white.png";

const DelayedFallback = () => {
    const [show, setShow] = useState(true)

    return (
        <>
            {show &&
            <Box minHeight="100vh">
                <Image
                    className="center"
                    width="200px"
                    height="85px"
                    src={logo}
                    alt="Indie app"
                    objectFit="contain"/>

            </Box>}
        </>
    )
}
export default DelayedFallback